export const limiteInput = ({e, setearValor, handleInputChange, limit, value, name}) => {
    if(value.length < limit){
        handleInputChange(e)
    }else{
        setearValor(name, e.target.value.slice(0, limit));
    }
}